<template>
<v-dialog v-model="show" max-width="600" scrollable>
  <template v-slot:activator="{on}">
    <slot name="activator" :on="on">
      <v-btn v-on="on" color="primary">Release Queue</v-btn>
    </slot>
  </template>
  <v-card>
    <CardTitle title="Release Queue">
      <template v-slot:actions>
        <v-btn @click="show = false" icon><v-icon>mdi-close</v-icon></v-btn>
      </template>
    </CardTitle>
    <v-card-text>
      <v-list>
        <v-list-item v-for="item in Array.from(queue, ([name,value]) => value)">
          <v-list-item-action class="mr-3">
            <v-chip color="success" v-if="item.status.toLowerCase() === 'success'">Success</v-chip>
            <v-chip color="primary" v-else-if="item.status.toLowerCase === 'Queued'">Queued</v-chip>
            <v-chip color="error" v-else>Failed</v-chip>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-subtitle>Sample ID</v-list-item-subtitle>
            <v-list-item-title>{{item.sample_id}}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-content>
            <v-list-item-subtitle>Cert Regeneration</v-list-item-subtitle>
            <v-list-item-title>{{item.regen_cert}}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action v-if="item.status.toLowerCase().includes('fail')">
            <v-btn small color="error">Requeue</v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  name: "SampleQueue",
  data: () => ({
    show: false,
  }),
  props:{
    queue:{
      required: true,
    }
  },
  computed:{
    sampleQueue(){
      return Array.from(this.queue)
    }
  }
}
</script>

<style scoped>

</style>